import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "dark",
    primary: { main: "#7c3aed", light: "#a78bfa" },
    secondary: { main: "#94a3b8" },
    background: {
      default: "#0f172a",
      paper: "#1e293b",
    },
    error: { main: "#f87171" },
    warning: { main: "#fbbf24" },
    success: { main: "#34d399" },
    info: { main: "#60a5fa" },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
    divider: "#334155",
  },
  typography: {
    fontFamily: "'Inter', sans-serif",
    fontSize: 13,
  },
  shape: {
    borderRadius: 2,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#0f172a",
          backgroundImage: "none",
          borderBottom: "1px solid #1e293b",
          boxShadow: "none",
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        root: { display: "none !important" },
        paper: { display: "none !important" },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none", borderRadius: 2 },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: { borderRadius: 2, boxShadow: "none" },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderColor: "#1e293b", padding: "10px 14px" },
        head: {
          fontWeight: 600,
          fontSize: "0.7rem",
          color: "#64748b",
          borderBottom: "2px solid #334155",
          textTransform: "none",
          letterSpacing: 0.5,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          "&:hover": {
            backgroundColor: "rgba(124,58,237,0.04) !important",
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 500, fontSize: "0.75rem", borderRadius: 2 },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", fontWeight: 600, borderRadius: 2, letterSpacing: 0.3 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#7c3aed",
          },
        },
        notchedOutline: {
          borderColor: "#334155",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          minHeight: 36,
          "&.Mui-selected": { color: "#a78bfa" },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: { backgroundColor: "#7c3aed", height: 2 },
        root: { minHeight: 36 },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderColor: "#334155",
          borderRadius: 2,
          "&.Mui-selected": {
            backgroundColor: "rgba(124,58,237,0.15)",
            color: "#a78bfa",
            borderColor: "#7c3aed",
          },
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: { backgroundColor: "rgba(124,58,237,0.15)", borderRadius: 0 },
        bar: { backgroundColor: "#7c3aed" },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { borderRadius: 2 },
      },
    },
    RaEmpty: {
      styleOverrides: {
        icon: { display: "none" },
      },
    },
  },
});
